module.exports = __webpack_public_path__ + "img/iconFilter.7fb03635.svg";